module.exports = __webpack_public_path__ + "static/media/ionicon.1c4f4979.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/ionicon/ionicon.woff?phty4a
 ** module id = 180
 ** module chunks = 0
 **/